// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               v5.26.1
// source: atk/job_type.proto

/* eslint-disable */

export const protobufPackage = "carbon.atk";

export enum JobType {
  JOB_TYPE_UNSPECIFIED = 0,
  LASER_WEED = 1,
  GROUND_PREP = 2,
  TRANSPORT = 3,
  IN_SEASON = 4,
  UNRECOGNIZED = -1,
}

export function jobTypeFromJSON(object: any): JobType {
  switch (object) {
    case 0:
    case "JOB_TYPE_UNSPECIFIED":
      return JobType.JOB_TYPE_UNSPECIFIED;
    case 1:
    case "LASER_WEED":
      return JobType.LASER_WEED;
    case 2:
    case "GROUND_PREP":
      return JobType.GROUND_PREP;
    case 3:
    case "TRANSPORT":
      return JobType.TRANSPORT;
    case 4:
    case "IN_SEASON":
      return JobType.IN_SEASON;
    case -1:
    case "UNRECOGNIZED":
    default:
      return JobType.UNRECOGNIZED;
  }
}

export function jobTypeToJSON(object: JobType): string {
  switch (object) {
    case JobType.JOB_TYPE_UNSPECIFIED:
      return "JOB_TYPE_UNSPECIFIED";
    case JobType.LASER_WEED:
      return "LASER_WEED";
    case JobType.GROUND_PREP:
      return "GROUND_PREP";
    case JobType.TRANSPORT:
      return "TRANSPORT";
    case JobType.IN_SEASON:
      return "IN_SEASON";
    case JobType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
